import type {
  Image,
  ImageContent,
  PersonalizedImageContent,
} from "./contentItemSchemas";
import {
  imageContentFieldsSchema,
  imageSchema,
  personalizedImageContentFieldsSchema,
  parseImageContentFromFields,
  parsePersonalizedImageContentFromFields,
  parseWithRecord,
} from "./schemas";

export const parseImage = (item: unknown): Image =>
  parseWithRecord(item, imageSchema);

export const parseImageContent = (
  item: unknown,
  formLabel?: string,
): ImageContent => {
  const parsed = parseWithRecord(item, imageContentFieldsSchema);
  return parseImageContentFromFields(parsed, formLabel);
};

export const parsePersonalizedImageContent = (
  item: unknown,
  formLabel?: string,
): PersonalizedImageContent => {
  const parsed = parseWithRecord(item, personalizedImageContentFieldsSchema);
  return parsePersonalizedImageContentFromFields(parsed, formLabel);
};
